import { createContext } from 'react';

type UserSettings = {
  anonymized: boolean;
  showPassed: boolean;
  emailProductUpdates?: boolean;
  termsAcceptedAt?: Date;
};

export type UserContext = {
  userSettings: {
    id?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    phone?: string;
    loggedIn?: boolean;
    company?: { id: string; name: string; admin: boolean };
    settings?: UserSettings;
    state?: SessionState;
    canActAs: { id: string; email: string }[];
  };
  logout?: () => void;
  setLoggedIn?: (loggedIn: boolean) => void;
  switchTo?: (id: string) => void;
  setUserVariables?: (newUser: {
    user: {
      id?: string;
      firstName?: string;
      lastName?: string;
      email?: string;
      phone?: string;
      contact?: string;
      company?: { admin: boolean; name: string; id: string };
      settings?: Partial<UserSettings>;
      state?: SessionState;
      canActAs?: { id: string; email: string }[];
    };
  }) => void;
};

export type SetUserVariables = Required<UserContext>['setUserVariables'];

export const SessionState = {
  LoggingOut: -1,
  LoggedOut: 0,
  LoggedIn: 1,
} as const;

export type SessionState = (typeof SessionState)[keyof typeof SessionState];

const LocaleContext = createContext({} as UserContext);

export default LocaleContext;
